/* ============================================
   SUVENE — Featured Collection Card Spacing
   ============================================ */

(function() {
  'use strict';

  function applySpacing() {
   document.querySelectorAll('.wt-featured-collection .card__container > div.card.card--left').forEach(card => {
      if (card.tagName === 'A') return;
      const isMobile = window.innerWidth <= 899;
      card.style.setProperty('padding-top', isMobile ? '14px' : '18px', 'important');
      card.style.setProperty('margin-top', '0', 'important');
      
      // Desktop: Flex-Layout (Title ↔ Preis), Mobile: Block
      if (isMobile) {
        card.style.setProperty('display', 'block', 'important');
      } else {
        card.style.setProperty('display', 'flex', 'important');
        card.style.setProperty('align-items', 'baseline', 'important');
        card.style.setProperty('justify-content', 'space-between', 'important');
        card.style.setProperty('gap', '10px', 'important');
        card.style.setProperty('width', '100%', 'important');
      }
    });

    document.querySelectorAll('#product-grid .card__container > div.card.card--left, .collection__grid .card__container > div.card.card--left').forEach(card => {
      if (card.tagName === 'A') return;
      const isMobile = window.innerWidth <= 749;
      card.style.setProperty('padding-top', isMobile ? '10px' : '14px', 'important');
      card.style.setProperty('margin-top', '0', 'important');
    });
  }

  function init() {
    applySpacing();
    window.addEventListener('resize', applySpacing);

    const observer = new MutationObserver(function(mutations) {
      let shouldReapply = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          const target = mutation.target;
          if (target.classList && target.classList.contains('card--left') && target.tagName !== 'A') {
            shouldReapply = true;
          }
        }
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1 && (
              node.classList && (node.classList.contains('swiper-slide') || (node.querySelector && node.querySelector('.card.card--left')))
            )) {
              shouldReapply = true;
            }
          });
        }
      });
      if (shouldReapply) applySpacing();
    });

    document.querySelectorAll('.wt-slider__container, [data-swiper], #product-grid').forEach(container => {
      observer.observe(container, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    });

    setTimeout(applySpacing, 100);
    setTimeout(applySpacing, 500);
    setTimeout(applySpacing, 1000);
    setTimeout(applySpacing, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();